import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  width: 516px;
  padding-bottom: 40px;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  border-radius: 16px;
  background: var(--alias-color-background-normal-normal);
  box-sizing: border-box;
  position: relative;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  padding: 20px 24px;

  border-bottom: 2px solid var(--alias-color-line-normal);
`;

export const Section = styled.div`
  display: flex;
  padding: 0px 48px;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  align-self: stretch;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
`;

export const RepeatOption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

export const Unit = styled.div<{ show?: boolean }>`
  width: 198px;
  gap: 4px;
  display: ${({ show }) => (show ? "flex" : "none")};
  flex-direction: column;
`;

export const DaysContainer = styled.div<{ show?: boolean }>`
  display: ${({ show }) => (show ? "flex" : "none")};
  align-items: flex-start;
  gap: 12px;
`;

export const Day = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const EndRule = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

export const Options = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
`;

export const Option = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const CancelBtn = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;

  cursor: pointer;
`;
